module.exports = __webpack_public_path__ + "static/media/a2.a317f51c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ArcadeRoyale/a2.jpg
// module id = 162
// module chunks = 0